module.exports = {
    /**
     * Предзагрузка всех фоновых изображений в кэш браузера
     */
    async start() {

        window.cacheImages = [];
        const images = [];
        let video = null;
        window.project.slides.forEach(slide => {
            const data = JSON.parse(slide.data);
            if (data) {
                if (data.bgImage) {
                    images.push(data.bgImage);
                }
                if (data.bgVideo) {
                    video = '/' + data.bgVideo;
                }
                if (data.pointImages) {
                    data.pointImages.forEach(e => {
                        images.push(e.path);
                    })
                }
            }

        });
        if (images.length > 0) {
            images.forEach(image => {
                const img = new Image();
                img.src= '/' + image;
                cacheImages.push({
                    el: img,
                    src: image
                });
            });
            const imageUrls = cacheImages.map(e => '/' + e.src);
            console.log(cacheImages);
            await module.exports.loadImages(imageUrls);
            
        }
    },

    /**
     * Метод загрузки картинок
     * @param images
     * @return {Promise<*[]>}
     */
    async loadImages(images) {
        const loadedImages = [];
        for (let i = 0; i < images.length; i++) {
            const img = new Image();
            img.src = images[i];
            loadedImages.push(
                new Promise(resolve => {
                    img.onload = () => {
                        resolve(img);
                    };
                    img.onerror = () => {
                        resolve(false)
                    }
                }).catch(error => {
                    console.log(`%cBOOTLOADER: Ошибка загрузки: ${images[i]}: ${error}`, 'color:red');
                })
            );
        }
        return Promise.allSettled(loadedImages).then(results => {
            const fulfilledImages = results.filter(result => result.status === "fulfilled").map(result => result.value);
            console.log(`%cBOOTLOADER: Загружено изображений: ${fulfilledImages.length}`, 'color: green');
            return fulfilledImages;
        });
    },

    async preloadVideo(videoSrc) {
        const video = document.createElement('video');
        video.src = videoSrc;
        video.preload = 'metadata';

        window.cacheVideo = {
            el: video,
            src: videoSrc
        }

        document.body.appendChild(video);
        return new Promise((resolve, reject) => {
            video.onloadedmetadata = () => {
                document.body.removeChild(video);
                resolve(video);
            };
            video.onerror = (error) => {
                console.log(`%cBOOTLOADER: Ошибка загрузки видео: ${videoSrc}: ${error}`, 'color:red');
                document.body.removeChild(video);
                resolve(false);
            };
        }).catch(error => {
            console.log(`%cBOOTLOADER: Ошибка загрузки видео: ${videoSrc}: ${error}`, 'color:red');
        });
    }



}
